import { render, staticRenderFns } from "./ConfirmationMessage.vue?vue&type=template&id=31c34781"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=js"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports